/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WeightUpsertRequestDto
 */
export interface WeightUpsertRequestDto {
    /**
     * Weight value
     * @type {number}
     * @memberof WeightUpsertRequestDto
     */
    value: number;
    /**
     * Weight unit
     * @type {string}
     * @memberof WeightUpsertRequestDto
     */
    unit: WeightUpsertRequestDtoUnitEnum;
}


/**
 * @export
 */
export const WeightUpsertRequestDtoUnitEnum = {
    Kg: 'kg',
    Lbs: 'lbs'
} as const;
export type WeightUpsertRequestDtoUnitEnum = typeof WeightUpsertRequestDtoUnitEnum[keyof typeof WeightUpsertRequestDtoUnitEnum];


/**
 * Check if a given object implements the WeightUpsertRequestDto interface.
 */
export function instanceOfWeightUpsertRequestDto(value: object): value is WeightUpsertRequestDto {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    return true;
}

export function WeightUpsertRequestDtoFromJSON(json: any): WeightUpsertRequestDto {
    return WeightUpsertRequestDtoFromJSONTyped(json, false);
}

export function WeightUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeightUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'unit': json['unit'],
    };
}

export function WeightUpsertRequestDtoToJSON(json: any): WeightUpsertRequestDto {
    return WeightUpsertRequestDtoToJSONTyped(json, false);
}

export function WeightUpsertRequestDtoToJSONTyped(value?: WeightUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
        'unit': value['unit'],
    };
}

